import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// ---------- Public form submissions ----------
export const submitLead = (payload) =>
  apiClient.post("/leads", payload).then((r) => r.data);
export const submitBooking = (payload) =>
  apiClient.post("/bookings", payload).then((r) => r.data);
export const submitPeptideInquiry = (payload) =>
  apiClient.post("/peptide-inquiries", payload).then((r) => r.data);
export const subscribeNewsletter = (email) =>
  apiClient.post("/newsletter", { email }).then((r) => r.data);

// ---------- Admin ----------
const ADMIN_KEY = "ngp_admin_token";

export const getAdminToken = () => localStorage.getItem(ADMIN_KEY) || "";
export const setAdminToken = (t) => localStorage.setItem(ADMIN_KEY, t);
export const clearAdminToken = () => localStorage.removeItem(ADMIN_KEY);

const adminHeaders = () => ({ "X-Admin-Token": getAdminToken() });

export const adminLogin = (token) =>
  apiClient.post("/admin/login", { token }).then((r) => r.data);
export const adminGetStats = () =>
  apiClient.get("/admin/stats", { headers: adminHeaders() }).then((r) => r.data);
export const adminGetLeads = () =>
  apiClient.get("/admin/leads", { headers: adminHeaders() }).then((r) => r.data);
export const adminGetBookings = () =>
  apiClient.get("/admin/bookings", { headers: adminHeaders() }).then((r) => r.data);
export const adminGetPeptideInquiries = () =>
  apiClient.get("/admin/peptide-inquiries", { headers: adminHeaders() }).then((r) => r.data);
export const adminGetNewsletter = () =>
  apiClient.get("/admin/newsletter", { headers: adminHeaders() }).then((r) => r.data);
export const adminGetPayments = () =>
  apiClient.get("/admin/payments", { headers: adminHeaders() }).then((r) => r.data);

// ---------- Stripe payments ----------
export const createCheckoutSession = ({ packageId, originUrl, email, name }) =>
  apiClient
    .post("/payments/checkout/session", {
      package_id: packageId,
      origin_url: originUrl,
      email,
      name,
    })
    .then((r) => r.data);

export const getCheckoutStatus = (sessionId) =>
  apiClient.get(`/payments/checkout/status/${sessionId}`).then((r) => r.data);
